import { SET_PERMISSION } from "../actions/types";

const initialPermissions = false;

//Hide and Show toast messages
export const permissionReducer = (state = initialPermissions, { type, payload }) => {
  switch (type) {
    case SET_PERMISSION:
      return Array.isArray(payload) ? [...payload] : payload;
    default:
      return state;
  }
};
